module.exports = __webpack_public_path__ + "img/share.84d865e2.svg";